.no-page-access-alert {
    text-align: center;
    color: #545cd8;
}
